<template>
  <div class="home_page orderList">
    <!-- 状态 -->
    <div class="s2b_purchout_tabs">
      <div v-for="item in statusList"
            :key="item.value"
            class="tabs_item cursor-pointer"
            @click="tabsClick(item)"
            :class="{'tabs_item_choosed': item.value === dataForm.orderStatus}">
        {{item.name}}
        <span v-show="item.count" class="tabs_item_count">({{item.count}})</span>
      </div>
    </div>
    <!-- 筛选条件 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>
          <i class="el-icon-search"></i>
          筛选查询
        </span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
      </div>
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item label="输入搜索：">
          <el-input v-model="dataForm.orderMsg" placeholder="订单编号/商品编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人：">
          <el-input v-model="dataForm.userInfo" placeholder="收货人姓名/手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="提交时间：">
          <!-- <el-date-picker
            v-model="dataForm.startTime"
            type="date"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker> -->
          <el-date-picker
            v-model="dataForm.timeSlot"
            type="daterange"
            range-separator="至"
            start-placeholder="提交开始日期"
            end-placeholder="提交结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList(1)" type="primary">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 数据展示 -->
    <div class="table_data">
      <el-table
        :data="dataList"
        :span-method="arraySpanMethod"
        v-loading="dataLoading"
        border
        style="width: 100%">
        <el-table-column
          prop="name"
          header-align="center"
          label="商品图片"
          min-width="70px">
          <template slot-scope="scope">
            <div v-if="scope.row.goodFlag" class="good_img">
              <img :src="scope.row.fileUrls || defaultImg"
                alt=""
                class="cursor-pointer"
                width="60px"
                height="60px"
                @click="goodDetailHandle(scope.row)"
              >
            </div>
            <div v-else class="order_info">
              <div class="info_item">订单编号：{{scope.row.mainOrderCode}}</div>
              <div class="info_item">提交时间：{{scope.row.createTime}}</div>
              <div class="info_item">订单金额：{{scope.row.orderMoney}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityName"
          align="center"
          label="商品">
          <template slot-scope="scope">
            <div @click="goodDetailHandle(scope.row)">{{scope.row.commodityName}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityModel"
          align="center"
          label="规格">
        </el-table-column>
        <el-table-column
          prop="commodityNum"
          align="center"
          label="数量">
        </el-table-column>
        <el-table-column
          prop="commodityPrice"
          align="center"
          label="成交价">
        </el-table-column>
        <el-table-column
          prop="commodityTotalPrice"
          align="center"
          label="成交金额">
        </el-table-column>
        <!-- <el-table-column
          prop="amount3"
          align="center"
          label="订单来源">
        </el-table-column> -->
        <el-table-column
          prop="orderStatus"
          align="center"
          label="状态">
          <template slot-scope="scope">
            {{$getDictLabel('MAIN_ORDER_STATUS' ,scope.row.orderStatus)}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="orderDetailHandle(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="dataForm.page"
                    :page-size="dataForm.limit"
                    :total="total"
                    class="s2b_page"
                    prev-text="上一页"
                    next-text="下一页"
                    style="text-align: center;"
                    layout="total, prev, pager, next, jumper"
                    @current-change="getDataList">
                    <!-- :page-sizes="[10, 20, 50, 100]"
                    @size-change="pageSizeChangeHandle" -->
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'punchoutOrderList', // punchout订单列表页
  data () {
    return {
      // 状态列表
      statusList: [
        {
          name: '全部',
          value: '',
          count: 0
        },
        {
          name: '审核中',
          value: '8',
          count: 0
        },
        {
          name: '已下单',
          value: '11',
          count: 0
        },
        // {
        //   name: '待发货',
        //   value: ''
        // },
        {
          name: '已发货',
          value: '15',
          count: 0
        },
        {
          name: '已完成',
          value: '19',
          count: 0
        },
        {
          name: '已关闭',
          value: '99',
          count: 0
        }
      ],
      dataForm: {
        orderStatus: '',
        orderMsg: '',
        userInfo: '', // 收货人
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        timeSlot: null
      },
      total: 0,
      dataLoading: false,
      dataList: [],
      defaultImg: require('@/assets/img/bitmap.png')
    }
  },
  computed: {},
  created () {

  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    // 切换tab
    tabsClick (item) {
      this.dataForm.orderStatus = item.value
      this.dataForm.orderMsg = ''
      this.dataForm.userInfo = ''
      this.dataForm.timeSlot = null
      this.getDataList(1)
    },
    // 获取数据列表
    getDataList (page = this.dataForm.page) {
      this.getCount()
      this.dataForm.page = page
      this.dataLoading = true
      if (this.dataForm.timeSlot && this.dataForm.timeSlot.length) {
        this.dataForm.startTime = this.dataForm.timeSlot[0] + ' 00:00:00'
        this.dataForm.endTime = this.dataForm.timeSlot[1] + ' 23:59:59'
      } else {
        this.dataForm.startTime = null
        this.dataForm.endTime = null
      }
      this.$http.post(`/openapi/punchoutOrder/myOrderList`, this.dataForm)
        .then(({ data }) => {
          if (data.resultCode !== '0') {
            this.total = 0
            this.dataList = []
            return false
          }
          let dataList = []
          data.result.data.forEach(item => {
            dataList.push({
              mainOrderId: item.mainOrderId,
              mainOrderCode: item.mainOrderCode,
              orderMoney: item.orderMoney,
              orderStatus: item.orderStatus,
              createTime: item.createTime,
              goodFlag: false
            })
            if (item.commodityDetails && item.commodityDetails.length) {
              let goodList = item.commodityDetails.map(good => {
                return {
                  mainOrderId: item.mainOrderId,
                  goodFlag: true,
                  orderStatus: item.orderStatus,
                  ...good
                }
              })
              dataList.push(...goodList)
            }
          })
          this.total = Number(data.result.count) || 0
          this.dataList = dataList || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 获取各状态数量
    getCount () {
      let statusList = this.statusList.map(item => {
        return {
          ...item,
          count: 0
        }
      })
      this.$http.get(`/openapi/punchoutOrder/orderStatusCount`)
        .then(({ data }) => {
          if (data.resultCode !== '0') {
            this.statusList = statusList
            return false
          }
          statusList[1].count = data.result.pendingApproval || 0
          statusList[2].count = data.result.confirmOrder || 0
          statusList[3].count = data.result.onDelivery || 0
          statusList[4].count = data.result.already || 0
          statusList[5].count = data.result.OrderCancel || 0
          this.statusList = statusList
        })
    },
    // 合并列
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (!row.goodFlag) {
        // 如果是主行合并列
        if (columnIndex === 0) {
          return [1, 8]
        } else if (columnIndex !== 0) {
          return [0, 0]
        }
      } else if (columnIndex === 6 || columnIndex === 7) {
        // 该订单包含主行的list
        let list = this.dataList.filter(item => {
          return item.mainOrderId === row.mainOrderId
        })
        // 该订单包主行的下标 index + 1为商品第一行
        let index = this.dataList.findIndex(item => {
          return item.mainOrderId === row.mainOrderId
        })
        if (rowIndex === (index + 1)) {
          // 列合并
          return [list.length - 1, 1]
        } else {
          return [0, 0]
        }
      }
    },
    // 查看详情
    orderDetailHandle (row) {
      this.$router.push({
        name: 'punchoutOrderDetail',
        query: {
          id: row.mainOrderId
        }
      })
    },
    // 跳转商品详情
    goodDetailHandle (row) {
      this.$router.push({
        name: 'punchoutGoodsDetail',
        query: {
          skuId: row.skuId,
          spuId: row.spuId
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.orderList{
  height: 100vh;
  .s2b_purchout_tabs{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 55px;
    background: #fff;
    .tabs_item{
      // min-width: 120px;
      padding: 0 45px;
      color: #1d65a8;
      text-align: center;
      .tabs_item_count{
        color: #F04844;
      }
    }
    .tabs_item_choosed{
      background: #1d65a8;
      color: #fff;
    }
  }
  .box-card{
    margin-top: 20px;
  }
  .table_data{
    margin-top: 20px;
    .good_img{
      // margin: auto;
      text-align: center;
    }
    .order_info{
      display: flex;
      align-items: center;
      .info_item{
        // flex-basis: 2;
        min-width: 200px;
        margin-right: 20px;
      }
    }
  }
}
</style>
